var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"movie-box page-margin-top3 page-text-center size"},[_vm._v("\n        ！请在微信客户端打开\n    ")])])
}]

export { render, staticRenderFns }